export default "__VITE_ASSET__Bz3owYzL__"